import React__default from 'react';

var RightSideIcon = function (_a) {
    var setActiveOverlay = _a.setActiveOverlay;
    return (React__default.createElement("div", { className: 'pgc-right-side-button', onClick: function () { return setActiveOverlay(true); } },
        React__default.createElement("i", { className: 'icon-menu' })));
};

export { RightSideIcon };
